import { cssVariables } from "@/utils/utils";
import { Button, Flex, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../../../common/components/views/Ellipsis";
import { formatCoverageLimitValues } from "../../../../../../../common/utils/formatUtils";
import { resolveInstitutionLogo } from "../../../../../../institution/utils";
import { ErrorAlert } from "../../../../components/calc-result/ErrorAlert";
import { RecommendationButton } from "../../../../components/calc-result/RecommendationButton";
import { CalcResult } from "../../../../types";
import { MtplCalcResultData } from "../../../types";

type Props = {
  item: CalcResult<MtplCalcResultData>;
  rotate: () => void;
  handleItemRecommendation: (itemId: string, activation: boolean) => void;
};

export const MtplCalcResultInfo = ({ item, rotate, handleItemRecommendation }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex gap="middle" style={{ height: "100%" }}>
      <div style={{ marginTop: 10 }}>
        <img
          width="100"
          height="60"
          style={{ objectFit: "contain" }}
          src={resolveInstitutionLogo(item.insuranceInstitution)}
          alt="Institution Logo"
        />
      </div>

      <Flex justify="space-between" vertical flex={1} style={{ minWidth: 0 }}>
        <div>
          <Flex gap="middle">
            <h2 style={{ marginBottom: 14 }}>
              {`${item.insuranceInstitution.name} ${item.data?.coverageOverride ?? item.coverage}`}
            </h2>

            <RecommendationButton item={item} handleItemRecommendation={handleItemRecommendation} />
          </Flex>

          <div style={{ maxHeight: 115, overflowY: "auto" }}>
            {item.error ? (
              <ErrorAlert item={item} />
            ) : (
              <>
                <div className="margin-bottom-tiny">
                  <b>{t("contract.enums.insuranceCoverageType._label")}</b>
                </div>

                {item.data?.healthCoverageLimit && item.data.propertyCoverageLimit ? (
                  <div>
                    <Space>
                      <span>{t("calc.vehicle.results.coverageLimit")}</span>
                      <b>{formatCoverageLimitValues(item.data.healthCoverageLimit, item.data.propertyCoverageLimit)}</b>
                    </Space>
                  </div>
                ) : undefined}

                <p className="margin-top-tiny margin-bottom-tiny">
                  {item.data?.appliedCoverages
                    .map((coverage) => t("contract.enums.insuranceCoverageType." + coverage.type))
                    .join(", ")}
                </p>

                {item.data?.warnings.length ? (
                  <Tag
                    style={{ minWidth: 0, display: "block", paddingRight: 24, marginTop: 8, marginRight: 0 }}
                    icon={<AntIcon type="exclamation" />}
                    color="warning"
                  >
                    <Ellipsis style={{ color: cssVariables.colorYellow }}>{item.data?.warnings.join(" ")}</Ellipsis>
                  </Tag>
                ) : undefined}
              </>
            )}
          </div>
        </div>

        <Space.Compact block>
          <Button style={{ flex: 1 }} disabled={!!item.error} onClick={rotate}>
            {t("calc.travel.results.additionalInfo")}
          </Button>
          <Button style={{ flex: 1 }} disabled={!!item.error} onClick={rotate}>
            {t("common.documents")}
          </Button>
        </Space.Compact>
      </Flex>
    </Flex>
  );
};
